import { Box, Flex, Icon, IconButton, Image, useColorMode } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiMenu } from "react-icons/fi";
import { Link as RouterLink, Outlet } from "react-router-dom";
import { assets } from "../../../assets/assets";
import { urls } from "../../../urls";
import { NotificationBell } from "../../notifications/v2/NotificationBell";
import { Sidebar } from "./Sidebar";
import { useAppRole } from "./useAppRole";
import { useNavBadges } from "./useNavBadges";

export const AppShellV2 = () => {
  const { t } = useTranslation();
  const { colorMode } = useColorMode();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const role = useAppRole();
  const badges = useNavBadges();

  return (
    <Flex h="100vh" overflow="hidden">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} role={role} badges={badges} />
      <Flex direction="column" flex="1" overflow="hidden">
        {/* Mobile-only top bar: the hamburger + logo + bell. On desktop the sidebar is always
            visible and carries the bell next to the logo, so no top bar is rendered. */}
        <Flex
          display={{ base: "flex", lg: "none" }}
          align="center"
          gap="3"
          h="56px"
          px="4"
          flexShrink={0}
          bg="smBackground"
          borderBottom="1px solid"
          borderColor="smBorder"
        >
          <IconButton
            aria-label={t("Open menu")}
            icon={<Icon as={FiMenu} />}
            variant="ghost"
            size="sm"
            onClick={() => setSidebarOpen(true)}
          />
          <RouterLink to={urls.v2.home}>
            <Image src={colorMode === "dark" ? assets.logo_dark : assets.logo} alt="SourceMagnet" h="24px" />
          </RouterLink>
          <Box ml="auto">
            <NotificationBell />
          </Box>
        </Flex>
        <Box as="main" flex="1" overflowY="auto" bg="smBackgroundSecondary" p={{ base: "4", md: "6", lg: "8" }}>
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
};
